import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'gwx-voyager-components';
import OpportunityFormContainer from './Form/OpportunityForm.react';
import OpportunityListContainer from './List/OpportunityQueue.react';

/**
 * Containing component that presents the various Opportunities components
 * and their respective subroutes.
 */
const Opportunities = ({ match }) => (
	<div>
		<Switch>
			<Route exact path={match.path} />
			<Route exact path={`${match.path}/add`} component={OpportunityFormContainer} />
			<Redirect to='/pageNotFound' />
		</Switch>
		<OpportunityListContainer />
	</div>
);
Opportunities.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired
};

export default Opportunities;
